export default "__VITE_ASSET__DBhzpgPq__"